/**
 * MSQCard - MSQ baseline symptom card (PROD-646 Sprint 3.3).
 *
 * Thin wrapper around `PromCard` bound to the MSQ baseline definition.
 * Per master prompt v3.3 §4.3 Phase 2 the MSQ baseline ports as a six-
 * item symptom block. The Observation LOINC code is currently the
 * placeholder `LA31978-5`; clinical advisory must confirm a canonical
 * menopause / longevity LOINC before this card escapes Demo Mode (the
 * advisory flag is rendered on the card so the gap is visible).
 *
 * HC3: citation discipline + LOINC source live in `prom-definitions.ts`.
 * HC5: zero em / en dashes anywhere.
 */
import { PromCard, type PromCardProps } from './PromCard';
import { MSQ_DEFINITION } from './prom-definitions';

export type MSQCardProps = Omit<PromCardProps, 'definition'>;

export function MSQCard(props: MSQCardProps) {
  return <PromCard definition={MSQ_DEFINITION} {...props} />;
}
